import PropTypes from 'prop-types';
import styled from 'styled-components';
import smartButtonStyles from './smartButtonStyles';
import { SmartHandlerButton } from './SmartHandlerButton';

export const SmartButton = styled(SmartHandlerButton)`
  ${smartButtonStyles}
`;

SmartButton.defaultProps = {
  theme: {
    btnDefaultHover: '#cccccc',
    btnDefault: '#999',
    btnInactive: '#ebebeb'
  }
};

SmartButton.propTypes = {
  success: PropTypes.bool,
  danger: PropTypes.bool,
  disabled: PropTypes.bool
};

export default SmartButton;
